import { Footer } from "components/Footer";
import type React from "react";
import { StyledPageLayout } from "./MainPageLayout.styled";
interface MainPageLayoutProps {
  children: React.ReactNode;
  className?: string;
  header: React.ReactNode;
  navigationMenu: React.ReactNode;
  shouldShowHeader: boolean;
  shouldShowSideNav: boolean;
}

export const MainPageLayout: React.FC<MainPageLayoutProps> = ({
  children: content,
  className,
  navigationMenu,
  header,
  shouldShowHeader = false,
  shouldShowSideNav = false,
}) => {
  return (
    <StyledPageLayout
      className={className}
      $hasHeader={shouldShowHeader}
      $hasSideMenu={shouldShowSideNav}
      $centerContent={true}
    >
      {shouldShowHeader && header}
      {shouldShowSideNav && navigationMenu}
      <main>{content}</main>
      <Footer />
    </StyledPageLayout>
  );
};
